'use strict';

var _ = require('lodash');
var ChartLengthOfStayDirective = function ChartLengthOfStayDirective(Chart, Viewport, pricingAnalysisCommonsDataService) {
  return {
    restrict: 'E',
    template: require('../templates/chart-length-of-stay.html'),
    scope: {
      isChartVisible: '=?'
    },
    replace: true,
    controller: 'ChartLengthOfStayController',
    link: function link(scope, element) {
      var chartElement = element.find('.chart-container');
      var viewportElement = element.find('.viewport-container');
      var chart = new Chart(chartElement, scope.chartFormatters);
      var viewport = new Viewport(viewportElement, scope.viewportFormatters);
      function isOneBarVisible(data) {
        return _.filter(data, {
          isGap: false
        }).length === 1;
      }
      scope.renderChartDataPresent = _.debounce(function (data, selectionSize) {
        data = data || chart.data || [];
        selectionSize = selectionSize || data.length;
        if (scope.isChartVisible) {
          scope.data = data;
          chart.render(data);
          chart.setFilterBars();
          viewport.render(data, selectionSize, chart.getMaxRangeSize());
          scope.$broadcast('chart:lengthOfStay:fareChangePctReset');
          if (isOneBarVisible(data)) {
            scope.emitLengthOfStayServiceSelected(_.findIndex(data, {
              isGap: false
            }), true);
          }
        } else if (data) {
          chart.data = data;
        }
      }, 200, {
        leading: false,
        trailing: true
      });
      scope.renderPercentageBar = function () {
        var sparseWidth = _.map(chart.scales.xScale.domain(), function (domain) {
          return {
            lengthOfStay: domain,
            width: chart.params.xWidthFromLengthOfStay(domain),
            data: _.find(scope.data, {
              lengthOfStay: domain
            })
          };
        });
        scope.$broadcast('chart:lengthOfStay:sparseData', sparseWidth, chart.params);
      };
      chart.on('render', _.throttle(function () {
        scope.renderPercentageBar();
      }), 250);
      scope.toggleChartVisibility = function () {
        scope.isChartVisible = !scope.isChartVisible;
        if (scope.isChartVisible) {
          setTimeout(scope.renderChartDataPresent, 0);
        }
      };
      scope.$watch('isChartVisible', function (newValue, oldValue) {
        if (oldValue !== newValue && newValue === true) {
          setTimeout(scope.renderChartDataPresent, 0);
        }
      });
      scope.$on('chart:lengthOfStay:fareChangePctFilterChanged', function (event, pctFilter) {
        chart.setFilterBars(scope.filterDataByPCT(pctFilter));
      });
      scope.$on('chart:lengthOfStay:setInitialState', function () {
        _.forEach(scope.data, function (d) {
          d.selected = true;
        });
        scope.renderChartDataPresent(scope.data, scope.data.length);
      });
      chart.on('selectedLengthOfStay', function (evt, index) {
        if (scope.isChartVisible) {
          scope.emitLengthOfStayServiceSelected(index);
        }
      });
      viewport.on('rangechange', function (range) {
        if (scope.isChartVisible) {
          var slicedData = scope.data.slice(range[0], range[1]);
          chart.render(slicedData, range);
        }
      });
      scope.$on('$destroy', function () {
        chart.on('selectedLengthOfStay', null);
        viewport.on('rangechange', null);
      });
      scope.$on('chart:services:selectedService', function (evt, originalService) {
        if (pricingAnalysisCommonsDataService.isSingleItinerary(originalService)) {
          scope.isChartVisible = false;
          scope.data = [];
          return;
        }
        scope.redrawChart(originalService);
      });
      scope.resetViewportSelection = function (data, selectionSize) {
        viewport.render(data, selectionSize, chart.getMaxRangeSize());
      };
    }
  };
};
ChartLengthOfStayDirective.$inject = ['ChartLengthOfStay', 'ChartLengthOfStayViewport', 'PricingAnalysisCommonsDataService'];
module.exports = ChartLengthOfStayDirective;